import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {MenuButtonView} from '@fantasmagames/slot/src/modules/keypad/menuButton/MenuButtonView';
import {MenuButtonModule} from '@fantasmagames/slot/src/modules/keypad/menuButton/MenuButtonModule';
import {MenuButtonViewEvents} from '@fantasmagames/slot/src/modules/keypad/menuButton/MenuButtonViewEvents';

export class MenuButtonBasicState extends ModuleState<MenuButtonView, MenuButtonModule> {
	public onEnterState(): void {
	}

	public onLeaveState(): void {
	}

	protected setupEvents(): void {
		this.on(MenuButtonViewEvents.MENU_BUTTON_CLICKED, this.onMenuButtonClick);
	}

	protected onMenuButtonClick(): void {
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/keypad/menuButton/states/MenuButtonBasicState.ts